import { Icon } from "@iconify/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loading from "../../Shared/Loading";

const ContactsList = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("https://servercareseebd.careseebd.com/api/v1/contacts");
        const data = await response.json();
        setContacts(data);
        setLoading(false);
      } catch (error) {
        console.log("Error", error);
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const deleteContact = async (_id) => {
    const userConfirmation = window.confirm(
      "Are you sure you want to delete this contact message?"
    );

    if (!userConfirmation) return;

    try {
      const response = await fetch(
        `https://servercareseebd.careseebd.com/api/v1/contacts/${_id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        toast.success("Message deleted successfully");
        const updatedContacts = contacts.filter(
          (contact) => contact._id !== _id
        );
        setContacts(updatedContacts);
      } else {
        console.error("Failed to delete contact");
      }
    } catch (error) {
      console.error("Error deleting contact:", error);
    }
  };

  return (
    <div className="space-y-6 select-none">
      {/* Header card */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight flex items-center gap-2">
            <Icon icon="solar:chat-round-call-bold" className="text-cyan-500 w-6 h-6" />
            Contact Form Submissions
          </h1>
          <p className="text-[11px] text-slate-400 font-bold mt-1 uppercase tracking-wider">User inquiries and general feedback</p>
        </div>
        <div className="bg-indigo-50 border border-indigo-100 rounded-xl px-4 py-2 text-indigo-700 font-bold text-xs">
          Messages: <span className="text-indigo-900 font-black ml-1">{contacts.length}</span>
        </div>
      </div>

      {/* Table Container */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          {loading ? (
            <div className="py-20 flex justify-center items-center">
              <Loading />
            </div>
          ) : (
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50/75 border-b border-slate-100">
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Sender</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Email</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">City</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Phone</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Message</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-4 text-[11px] font-extrabold text-slate-500 uppercase tracking-wider text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {contacts.length > 0 ? (
                  contacts.map((contact) => (
                    <tr key={contact._id} className="hover:bg-slate-50/50 transition-colors">
                      <td className="px-6 py-4 text-xs font-bold text-slate-800">
                        {contact.name}
                      </td>
                      <td className="px-6 py-4 text-xs font-medium text-slate-500">
                        {contact.email}
                      </td>
                      <td className="px-6 py-4 text-xs font-semibold text-slate-650">
                        {contact.city || "N/A"}
                      </td>
                      <td className="px-6 py-4 text-xs font-medium text-slate-550">
                        {contact.phonenumber || "N/A"}
                      </td>
                      <td className="px-6 py-4 text-xs text-slate-500 max-w-xs truncate" title={contact.message}>
                        {contact.message}
                      </td>
                      <td className="px-6 py-4 text-[10px] font-bold text-slate-400 whitespace-nowrap">
                        {moment(contact?.createdAt).format("LL")}
                      </td>
                      <td className="px-6 py-4 text-xs">
                        <div className="flex justify-end">
                          <button
                            onClick={() => deleteContact(contact._id)}
                            className="p-1.5 text-slate-400 hover:text-rose-600 hover:bg-rose-50 border border-slate-200 hover:border-rose-150 rounded-lg transition-all cursor-pointer"
                            title="Delete Message"
                          >
                            <Icon icon="material-symbols:delete-outline" className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-10 text-xs text-slate-400">
                      No messages found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactsList;
